import { Directive, ElementRef } from '@angular/core';


@Directive({
  selector: 'carm-mde-popover-target, [carm-mde-popover-target]',
  exportAs: 'mdePopoverTarget'
})
export class MdePopoverTargetDirective { // tslint:disable-line:directive-class-suffix

  constructor(public _elementRef: ElementRef) { }

}
